// APP 配置
const APP_CONFIG = {
  //BASE_URL: 'http://172.80.8.205:1003',
  BASE_URL: 'http://api.amilan.com',
  COMPANY_NAME: localStorage.getItem('COMPANY_NAME') || '',
  VERSION: localStorage.getItem('VERSION') || '0.0.0',
};
export default APP_CONFIG;